import { Keyword } from "./keyword.js";
import { App } from "./app.js";

export type KeywordListWithKeywords = {
    id: string;
    created: Date;
    updated: Date;

    name: string;
    keywordIds: number[];
    keywords: Keyword[];

    userId: string;
    appId?: string;
    appCountry?: string;
    app?: App;

    /** Deduplicated map of app ID → icon URL for all apps referenced in keyword ranks. */
    iconsByAppId: Record<string, string>;
};

export function hasSyncingKeywords(keywordList: KeywordListWithKeywords): boolean {
    return keywordList.keywords.some((keyword) => keyword.syncing === true);
}
